import axios from "axios";
import {
  REACT_APP_SERVICE_API,
  REACT_APP_SERVICE_PUBLIC_API,
  REACT_APP_SERVICE_PUBLIC_API_V2,
  REACT_APP_PROJECT_SERVICE_API,
} from "../config/env";
import { getCookie } from "./cookie";

export const client = axios.create({
  baseURL: `${REACT_APP_SERVICE_API}`,
  headers: {
    Accept: "application/json",
  },
  responseType: "json",
});

export const clientPublic = axios.create({
  baseURL: `${REACT_APP_SERVICE_PUBLIC_API}`,
  headers: {
    Accept: "application/json",
  },
  responseType: "json",
});

export const clientPublicV2 = axios.create({
  baseURL: `${REACT_APP_SERVICE_PUBLIC_API_V2}`,
  headers: {
    Accept: "application/json",
  },
  responseType: "json",
});

export const clientPublicService = axios.create({
  baseURL: `${REACT_APP_PROJECT_SERVICE_API}`,
  headers: {
    Accept: "application/json",
  },
  responseType: "json",
});

client.defaults.headers.common["Authorization"] = getCookie(
  "access_token_admin"
)
  ? getCookie("access_token_admin")
  : "";

clientPublic.defaults.headers.common["Authorization"] = getCookie(
  "access_token_admin"
)
  ? getCookie("access_token_admin")
  : "";

export default { clientPublic, client, clientPublicV2 };
